import { Injectable, TransferState, makeStateKey } from '@angular/core';
import { DocumentNode, FetchResult } from '@apollo/client/core';
import { apolloHash } from 'utils/apollo-hash';

@Injectable({
  providedIn: 'root',
})
export class GraphqlStateService {
  constructor(private transferState: TransferState) {}

  hasState(documentNode: DocumentNode, variables: Record<string, any>): boolean {
    return this.transferState.hasKey<StateResult>(makeStateKey(apolloHash(documentNode, variables)));
  }
  getFromState<TData = Record<string, any>, TContext = Record<string, any>, TExtensions = Record<string, any>>(
    documentNode: DocumentNode,
    variables: Record<string, any>,
  ): StateResult<TData, TContext, TExtensions> {
    return this.transferState.get<StateResult<TData, TContext, TExtensions>>(
      makeStateKey(apolloHash(documentNode, variables)),
      null,
    );
  }

  setInState(documentNode: DocumentNode, variables: Record<string, any>, value: StateResult): void {
    this.transferState.set<StateResult>(makeStateKey(apolloHash(documentNode, variables)), value);
  }
}

type StateResult<
  TData = Record<string, any>,
  TContext = Record<string, any>,
  TExtensions = Record<string, any>,
> = FetchResult<TData, TContext, TExtensions>;
